var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('./internal'),
    request = _require.request,
    requestConfig = _require.requestConfig,
    offlineSerialize = _require.offlineSerialize,
    util = _require.util;

var defaultEnv = requestConfig.defaultEnv;

var _require$TierError = require("@oneledger/middle_utility").TierError,
    ErrorType = _require$TierError.ErrorType,
    ErrorUtil = _require$TierError.ErrorUtil;

var requestErrors = ErrorType.requestErrors;
/**
 * @description delegateTxOffline prepares delegate tx
 * @param parameters {Object} object of parameters
 * @param parameters.delegateAddress {string} delegator address
 * @param parameters.amount {Object} amount object
 * @param parameters.amount.currency {string} currency name
 * @param parameters.amount.value {string} amount
 * @param [parameters.gasAdjustment] {number} tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<response|error>} Promise.reject: error object , Promise.resolve: response object has rawTx with tx fee estimation
 */

function delegateTxOffline(_x) {
  return _delegateTxOffline.apply(this, arguments);
}
/**
 * @description undelegateTxOffline prepares undelegate tx
 * @param parameters {Object} object of parameters
 * @param parameters.undelegateAddress {string} delegator address
 * @param parameters.amount {Object} amount object
 * @param parameters.amount.currency {string} currency name
 * @param parameters.amount.value {string} amount
 * @param [parameters.gasAdjustment] {number} tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<response|error>} Promise.reject: error object , Promise.resolve: response object has rawTx with tx fee estimation
 */


function _delegateTxOffline() {
  _delegateTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref) {
    var delegateAddress,
        amount,
        _ref$gasAdjustment,
        gasAdjustment,
        env,
        sendingCurrency,
        checkAmountValueResult,
        _ref5,
        gasPrice,
        txPayload,
        assembledTx,
        gas,
        _ref6,
        feeEstimation,
        rawTx,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            delegateAddress = _ref.delegateAddress, amount = _ref.amount, _ref$gasAdjustment = _ref.gasAdjustment, gasAdjustment = _ref$gasAdjustment === void 0 ? 0 : _ref$gasAdjustment;
            env = _args.length > 1 && _args[1] !== undefined ? _args[1] : defaultEnv;

            if (util.isValidOLTAddress(delegateAddress)) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 4:
            _context.next = 6;
            return util.getCurrency(amount.currency);

          case 6:
            sendingCurrency = _context.sent;
            checkAmountValueResult = util.requestPriceConverter(amount.value, sendingCurrency.decimal);

            if (checkAmountValueResult) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.IllegalAmount)));

          case 10:
            amount.value = checkAmountValueResult; // check gasAdjustment if provided

            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context.next = 13;
              break;
            }

            return _context.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 13:
            _context.next = 15;
            return request.queryGasPrice(env);

          case 15:
            _ref5 = _context.sent;
            gasPrice = _ref5.response;
            txPayload = {
              delegationAddress: delegateAddress,
              amount: amount
            };
            assembledTx = util.assembleTxData(requestConfig.TxTypes.ADD_NETWORK_DELEGATE, txPayload, gasPrice, gasAdjustment);
            gas = assembledTx.fee.gas;
            _context.next = 22;
            return util.txFeeEstimator(gas, gasPrice);

          case 22:
            _ref6 = _context.sent;
            feeEstimation = _ref6.response;
            rawTx = util.rawTxStructure(offlineSerialize.jsonObjectToBase64(assembledTx));
            return _context.abrupt("return", Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, rawTx, {
              feeEstimation: feeEstimation
            }))));

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _delegateTxOffline.apply(this, arguments);
}

function undelegateTxOffline(_x2) {
  return _undelegateTxOffline.apply(this, arguments);
}
/**
 * @description delegateRewardWithdrawalTxOffline prepares delegate rewards withdrawal tx
 * @param parameters {Object} object of parameters
 * @param parameters.delegateAddress {string} delegator address
 * @param parameters.amount {Object} amount object
 * @param parameters.amount.currency {string} currency name
 * @param parameters.amount.value {string} amount
 * @param [parameters.gasAdjustment] {number} tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<response|error>} Promise.reject: error object , Promise.resolve: response object has rawTx with tx fee estimation
 */


function _undelegateTxOffline() {
  _undelegateTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(_ref2) {
    var undelegateAddress,
        amount,
        _ref2$gasAdjustment,
        gasAdjustment,
        env,
        sendingCurrency,
        checkAmountValueResult,
        _ref7,
        gasPrice,
        txPayload,
        assembledTx,
        gas,
        _ref8,
        feeEstimation,
        rawTx,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            undelegateAddress = _ref2.undelegateAddress, amount = _ref2.amount, _ref2$gasAdjustment = _ref2.gasAdjustment, gasAdjustment = _ref2$gasAdjustment === void 0 ? 0 : _ref2$gasAdjustment;
            env = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : defaultEnv;

            if (util.isValidOLTAddress(undelegateAddress)) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 4:
            _context2.next = 6;
            return util.getCurrency(amount.currency);

          case 6:
            sendingCurrency = _context2.sent;
            checkAmountValueResult = util.requestPriceConverter(amount.value, sendingCurrency.decimal);

            if (checkAmountValueResult) {
              _context2.next = 10;
              break;
            }

            return _context2.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.IllegalAmount)));

          case 10:
            amount.value = checkAmountValueResult; // check gasAdjustment if provided

            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context2.next = 13;
              break;
            }

            return _context2.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 13:
            _context2.next = 15;
            return request.queryGasPrice(env);

          case 15:
            _ref7 = _context2.sent;
            gasPrice = _ref7.response;
            txPayload = {
              delegator: undelegateAddress,
              amount: amount
            };
            assembledTx = util.assembleTxData(requestConfig.TxTypes.NETWORK_UNDELEGATE, txPayload, gasPrice, gasAdjustment);
            gas = assembledTx.fee.gas;
            _context2.next = 22;
            return util.txFeeEstimator(gas, gasPrice);

          case 22:
            _ref8 = _context2.sent;
            feeEstimation = _ref8.response;
            rawTx = util.rawTxStructure(offlineSerialize.jsonObjectToBase64(assembledTx));
            return _context2.abrupt("return", Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, rawTx, {
              feeEstimation: feeEstimation
            }))));

          case 26:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
  return _undelegateTxOffline.apply(this, arguments);
}

function delegateRewardWithdrawalTxOffline(_x3) {
  return _delegateRewardWithdrawalTxOffline.apply(this, arguments);
}
/**
 * @description delegateRewardReinvestTxOffline prepares delegate rewards reinvest tx
 * @param parameters {Object} object of parameters
 * @param parameters.delegateAddress {string} delegator address
 * @param parameters.amount {Object} amount object
 * @param parameters.amount.currency {string} currency name
 * @param parameters.amount.value {string} amount
 * @param [parameters.gasAdjustment] {number} tx gas adjustment, non-negative int, if not provided, default value will be 0
 * @param [env] {Object} environment parameters object
 * @param env.url {string} environment url (default is Kainos)
 * @param env.storeConfig {Object} store config
 * @param env.storeConfig.platform {string} store type. "electron" or "browser" (default is electron)
 * @param env.storeConfig.storeLocation {string} store location path (default is __dirname)
 * @return {Promise<response|error>} Promise.reject: error object , Promise.resolve: response object has rawTx with tx fee estimation
 */


function _delegateRewardWithdrawalTxOffline() {
  _delegateRewardWithdrawalTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(_ref3) {
    var delegateAddress,
        amount,
        _ref3$gasAdjustment,
        gasAdjustment,
        env,
        sendingCurrency,
        checkAmountValueResult,
        _ref9,
        gasPrice,
        txPayload,
        assembledTx,
        gas,
        _ref10,
        feeEstimation,
        rawTx,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            delegateAddress = _ref3.delegateAddress, amount = _ref3.amount, _ref3$gasAdjustment = _ref3.gasAdjustment, gasAdjustment = _ref3$gasAdjustment === void 0 ? 0 : _ref3$gasAdjustment;
            env = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : defaultEnv;

            if (util.isValidOLTAddress(delegateAddress)) {
              _context3.next = 4;
              break;
            }

            return _context3.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 4:
            _context3.next = 6;
            return util.getCurrency(amount.currency);

          case 6:
            sendingCurrency = _context3.sent;
            checkAmountValueResult = util.requestPriceConverter(amount.value, sendingCurrency.decimal);

            if (checkAmountValueResult) {
              _context3.next = 10;
              break;
            }

            return _context3.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.IllegalAmount)));

          case 10:
            amount.value = checkAmountValueResult; // check gasAdjustment if provided

            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context3.next = 13;
              break;
            }

            return _context3.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 13:
            _context3.next = 15;
            return request.queryGasPrice(env);

          case 15:
            _ref9 = _context3.sent;
            gasPrice = _ref9.response;
            txPayload = {
              delegator: delegateAddress,
              amount: amount
            };
            assembledTx = util.assembleTxData(requestConfig.TxTypes.REWARDS_WITHDRAW_NETWORK_DELEGATE, txPayload, gasPrice, gasAdjustment);
            gas = assembledTx.fee.gas;
            _context3.next = 22;
            return util.txFeeEstimator(gas, gasPrice);

          case 22:
            _ref10 = _context3.sent;
            feeEstimation = _ref10.response;
            rawTx = util.rawTxStructure(offlineSerialize.jsonObjectToBase64(assembledTx));
            return _context3.abrupt("return", Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, rawTx, {
              feeEstimation: feeEstimation
            }))));

          case 26:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));
  return _delegateRewardWithdrawalTxOffline.apply(this, arguments);
}

function delegateRewardReinvestTxOffline(_x4) {
  return _delegateRewardReinvestTxOffline.apply(this, arguments);
}

function _delegateRewardReinvestTxOffline() {
  _delegateRewardReinvestTxOffline = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(_ref4) {
    var delegateAddress,
        amount,
        _ref4$gasAdjustment,
        gasAdjustment,
        env,
        sendingCurrency,
        checkAmountValueResult,
        _ref11,
        gasPrice,
        txPayload,
        assembledTx,
        gas,
        _ref12,
        feeEstimation,
        rawTx,
        _args4 = arguments;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            delegateAddress = _ref4.delegateAddress, amount = _ref4.amount, _ref4$gasAdjustment = _ref4.gasAdjustment, gasAdjustment = _ref4$gasAdjustment === void 0 ? 0 : _ref4$gasAdjustment;
            env = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : defaultEnv;

            if (util.isValidOLTAddress(delegateAddress)) {
              _context4.next = 4;
              break;
            }

            return _context4.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddress)));

          case 4:
            _context4.next = 6;
            return util.getCurrency(amount.currency);

          case 6:
            sendingCurrency = _context4.sent;
            checkAmountValueResult = util.requestPriceConverter(amount.value, sendingCurrency.decimal);

            if (checkAmountValueResult) {
              _context4.next = 10;
              break;
            }

            return _context4.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.IllegalAmount)));

          case 10:
            amount.value = checkAmountValueResult; // check gasAdjustment if provided

            if (!(!Number.isInteger(gasAdjustment) || gasAdjustment < 0)) {
              _context4.next = 13;
              break;
            }

            return _context4.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidGasAdjustment)));

          case 13:
            _context4.next = 15;
            return request.queryGasPrice(env);

          case 15:
            _ref11 = _context4.sent;
            gasPrice = _ref11.response;
            txPayload = {
              delegator: delegateAddress,
              amount: amount
            };
            assembledTx = util.assembleTxData(requestConfig.TxTypes.REWARDS_REINVEST_NETWORK_DELEGATE, txPayload, gasPrice, gasAdjustment);
            gas = assembledTx.fee.gas;
            _context4.next = 22;
            return util.txFeeEstimator(gas, gasPrice);

          case 22:
            _ref12 = _context4.sent;
            feeEstimation = _ref12.response;
            rawTx = util.rawTxStructure(offlineSerialize.jsonObjectToBase64(assembledTx));
            return _context4.abrupt("return", Promise.resolve(ErrorUtil.responseWrap(_objectSpread({}, rawTx, {
              feeEstimation: feeEstimation
            }))));

          case 26:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));
  return _delegateRewardReinvestTxOffline.apply(this, arguments);
}

module.exports = {
  delegateTxOffline: delegateTxOffline,
  undelegateTxOffline: undelegateTxOffline,
  delegateRewardWithdrawalTxOffline: delegateRewardWithdrawalTxOffline,
  delegateRewardReinvestTxOffline: delegateRewardReinvestTxOffline
};